export default __webpack_public_path__ + "static/media/draft_plan.57d0c171.jpg";